/* ------------------------- External Dependencies -------------------------- */
import { connect } from 'react-redux';

/* ------------------------- Internal Dependencies -------------------------- */
import Render from './render';

/* ------------------------ Initialize Dependencies ------------------------- */

/* ---------------------------- Module Package ------------------------------ */
import { } from 'store/departments/actions'

function mapStateToProps(state) {
  return {
    
  };
}

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(Render);



// WEBPACK FOOTER //
// ./src/interface/atomic/organisms/MacbookDisplay/index.js